import { useNavigate } from "react-router-dom";
import GetAQuoteButton from "../GetAQuoteButton";
import classes from "./ProductListCard.module.css";

export default function ProductListCard({ product, loading = false }) {
  const navigate = useNavigate();

  const handleViewProduct = () => {
    const slug = product.product_slug || product.sku;
    navigate(`/product/${slug}`);
  };

  if (loading) {
    return (
      <div className={classes.listSkeleton}>
        <div className={classes.imageSkeleton}></div>
        <div className={classes.contentSkeleton}>
          <div className={classes.titleSkeleton}></div>
          <div className={classes.skuSkeleton}></div>
          <div className={classes.priceSkeleton}></div>
          <div className={classes.categorySkeleton}></div>
          <div className={classes.buttonSkeleton}></div>
        </div>
      </div>
    );
  }

  const displayName =
    product.productName.length > 60
      ? product.productName.slice(0, 60) + "..."
      : product.productName;

  const showPrice = parseFloat(product.regularPrice) > 0;

  return (
    <div
      className={classes.productListCard}
      onClick={handleViewProduct}
      role="button"
    >
      <div className={classes.imageWrapper}>
        <img src={product.productImage} alt={product.productName} />
      </div>

      <div className={classes.contentWrapper}>
        <h3 title={product.productName}>{displayName}</h3>
        <p className={classes.productSku}>SKU: {product.sku}</p>

        {showPrice && (
          <p className={classes.productPrice}>
            {product.salePrice && parseFloat(product.salePrice) > 0 ? (
              <>
                <span className={classes.regularPrice}>
                  £
                  {Number(product.regularPrice).toLocaleString("en-UK", {
                    minimumFractionDigits: 2,
                  })}
                </span>
                £
                {Number(product.salePrice).toLocaleString("en-UK", {
                  minimumFractionDigits: 2,
                })}
              </>
            ) : (
              `£${Number(product.regularPrice).toLocaleString("en-UK", {
                minimumFractionDigits: 2,
              })}`
            )}
          </p>
        )}

        {product.categoryName && (
          <p className={classes.productCategory}>{product.categoryName}</p>
        )}

        <div onClick={(e) => e.stopPropagation()}>
          <GetAQuoteButton sku={product.sku} />
        </div>
      </div>
    </div>
  );
}
